"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _system = require("@/api/system");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ["editItem"],
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      formData: {
        white_list: "",
        status: "0",
        member_id: "0"
      },
      options: [{
        value: "0",
        label: "管理后台"
      }, {
        value: "1",
        label: "供应商后台"
      }
      // {
      //     value: "2",
      //     label: "商户后台",
      // },
      ],

      value: "0",
      rules: {
        white_list: [{
          required: false,
          message: "请输入IP地址",
          trigger: "blur"
        }, {
          validator: this.validateIPAddress,
          trigger: "change"
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          // this.init();
          _this.getData();
        });
      } else {
        // this.dialogVisible = false;
        this.$refs["formData"].resetFields();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    validateIPAddress: function validateIPAddress(rule, value, callback) {
      // console.log("value: ", value);
      if (!value) {
        callback();
        return;
      }
      var addresses = value.split(",");
      for (var i = 0; i < addresses.length; i++) {
        var ip = addresses[i].trim();
        if (!/^((\d{1,3}\.){3}\d{1,3})$|^(?:(?:\d{1,3}\.){2})\*|(\d{1,3}\.\*)$|^[\u4E00-\u9FFF]+$/.test(ip) && !/^[\u4E00-\u9FFF]+$/.test(ip)) {
          callback(new Error("IP 地址格式不正确"));
        }
      }
      callback();
    },
    selectMemberId: function selectMemberId(e) {
      /**
       * 直接将 currentList 中的 white_list 赋值给 this.formData，并没有创建一个新的对象。
       * 这意味着 this.formData 与 currentList 共享引用关系，
       * 它们指向同一个内存地址。因此，当在代码的其他位置修改 this.formData 或 currentList 的 white_list 时，相互之间会互相影响。
       **/
      var currentList = this.allWhiteList.find(function (list) {
        return list.member_id == e;
      });
      console.log("currentList", currentList);
      if (currentList.white_list) {
        var white_list = currentList.white_list;
        console.log("white_list", white_list);
        this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formData), {}, {
          white_list: white_list
        }); // 解构赋值更新 white_list
        this.formData = this.formData.white_list;
        console.log("this.formData11", this.formData);
      } else {
        this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formData), {}, {
          white_list: "",
          member_id: currentList.member_id
        }); // 解构赋值更新 white_list 和 member_id
        // this.formData = this.formData.white_list;
      }

      console.log("this.formData", this.formData);
    },
    getData: function getData() {
      var _this2 = this;
      this.formData.member_id = this.editItem.id;
      this.loading = true;
      var params = {
        member_id: this.formData.member_id
      };
      (0, _system.getWhiteIpList)((0, _objectSpread2.default)({}, params)).then(function (res) {
        if (res) {
          // console.log("res", res);
          _this2.formData = res;
        }
        _this2.loading = false;
      });
    },
    submit: function submit() {
      var _this3 = this;
      // console.log("this.formData", this.formData);
      try {
        this.$refs.formData.validate(function (valid) {
          if (valid) {
            console.log("校验成功", _this3.formData);
            _this3.loading = true;
            (0, _system.saveWhiteIpList)(_this3.formData).then(function (res) {
              _this3.getData();
              _this3.loading = false;
            });
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
};
exports.default = _default;